import AddressSearchLib, {
  type AddressSearchPropsType,
  type AddressSearchStateType,
} from '@atpoint/atpjs/components/address_search'
import i18n from '@atpoint/atpjs/helpers/i18n'
import { addressSuggest, addressSuggestDetails } from '@forms/api/cybwell'
import { Grid, type WithStyles, withStyles } from '@material-ui/core'
import { autocompleteStyles } from '@merchant/components/autocomplete_styles'
import { Map as ImmutableMap } from 'immutable'
import { InputText } from 'swisscard/components/form'
import Autocomplete from 'swisscard/components/form/autocomplete'

type AddressInputProps = AddressSearchPropsType & {
  autocomplete: boolean
  className: string | Array<string>
  focused: boolean
  id: string
  label: string
} & WithStyles<typeof autocompleteStyles>

class AddressInput extends AddressSearchLib<AddressInputProps, AddressSearchStateType> {
  static defaultProps = {
    value: ImmutableMap({ street: '', zip: '', city: '' }),
    errorMessage: ImmutableMap(),
  }

  setStreet: (value: string) => void
  setZip: (value: string) => void
  setCity: (value: string) => void
  // loadAddress: (value: string | number | boolean) => void
  // loadAutocomplete: (search: string) => CancelablePromise

  constructor(props: AddressInputProps) {
    super(props)
    this.setStreet = this.setData.bind(this, 'street')
    this.setZip = this.setData.bind(this, 'zip')
    this.setCity = this.setData.bind(this, 'city')
  }

  apiAddressSuggestDetails(value: string) {
    return addressSuggestDetails(value)
  }

  apiAddressSuggest(search: string) {
    return addressSuggest(search)
  }

  setData(field: string, newValue: string) {
    const { onChange, value } = this.props
    if (onChange) {
      onChange(value.set(field, newValue))
    }
  }

  render() {
    const { autocomplete, classes, errorMessage, focused, id, label, value } = this.props

    const styleProps = {
      // style for the input field
      errorClassName: classes.errorMessage,
      labelClassName: classes.labelDefault,
      infoBottomClassName: classes.infoBottom,
      inputClassName: `${classes.inputDefault} ${classes.inputSearch}`,
      wrapperClassName: classes.inputWrapper,
      // styles for the suggestions list
      listClassName: classes.listClassName,
      listClassNameNoResults: classes.listClassNameNoResults,
      listEntryClassName: classes.listEntryClassName,
      listEntryClassNameNoResults: classes.listEntryClassNameNoResults,
      selectedEntryClassName: classes.selectedEntryClassName,
    }

    return (
      <div className={classes.inputWrapper}>
        <label className={classes.labelDefault} htmlFor={`${id}-street`}>
          {label}
        </label>
        {autocomplete ? (
          <Autocomplete
            {...styleProps}
            focused={focused}
            onChange={this.loadAddress}
            getResults={this.loadAutocomplete}
            value={value.get('street')}
            placeholder={i18n.trans(['address', 'street'])}
            label={i18n.trans(['address', 'street'])}
            errorMessage={
              ImmutableMap.isMap(errorMessage) && (errorMessage.get('street') as string | boolean | undefined)
            }
            id={`${id}-street`}
          />
        ) : (
          <InputText
            focused={focused}
            onChange={this.setStreet}
            value={value.get('street')}
            placeholder={i18n.trans(['address', 'street'])}
            label={i18n.trans(['address', 'street'])}
            errorMessage={
              ImmutableMap.isMap(errorMessage) && (errorMessage.get('street') as string | boolean | undefined)
            }
            id={`${id}-street`}
          />
        )}
        <Grid container>
          <Grid item xs={12} sm={4}>
            <InputText
              value={value.get('zip')}
              placeholder={i18n.trans(['address', 'zip'])}
              maxLength="5"
              errorMessage={
                ImmutableMap.isMap(errorMessage) && (errorMessage.get('zip') as string | boolean | undefined)
              }
              onChange={this.setZip}
              id={`${id}-zip`}
              showPlaceholder
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <InputText
              value={value.get('city')}
              placeholder={i18n.trans(['address', 'city'])}
              errorMessage={
                ImmutableMap.isMap(errorMessage) && (errorMessage.get('city') as string | boolean | undefined)
              }
              onChange={this.setCity}
              id={`${id}-city`}
              showPlaceholder
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

// @ts-ignore: AddressInput is not recognized as React Component
export const InputAddress = withStyles(autocompleteStyles)(AddressInput)
